import { connectTicketSelectionPage } from '../containers/ticketSelection/connectTicketSelectionPage';
import TicketSelectionFullSizePage from '../containers/ticketSelection/TicketSelectionFullSizePage';

export default connectTicketSelectionPage(TicketSelectionFullSizePage);
